import React, { useEffect } from "react";

import NavBar from "../components/navbar";
import Footer from "../components/footer";
import { useSelector, useDispatch } from "react-redux";
import {
  createProduct,
  deleteProduct,
  listProducts,
} from "../actions/productActions";
import {
  PRODUCT_CREATE_RESET,
  PRODUCT_DELETE_RESET,
} from "../reducers/actionTypes";
import LoadingBox from "../components/loadingBox";
import MessageBox from "../components/messageBox";
import { Link, useParams } from "react-router-dom";

function ProductListPage(props) {
  const { pageNumber = 1 } = useParams();
  const productList = useSelector((state) => state.productList);
  const { loading, products, error, page, pages } = productList;

  const productCreate = useSelector((state) => state.productCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    product: createdProduct,
  } = productCreate;

  const productDelete = useSelector((state) => state.productDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = productDelete;

  const dispatch = useDispatch();

  useEffect(() => {
    if (successCreate) {
      dispatch({ type: PRODUCT_CREATE_RESET });
      props.history.push(`/products/${createdProduct._id}/edit`);
    }
    if (successDelete) {
      dispatch({ type: PRODUCT_DELETE_RESET });
    }
    dispatch(listProducts({ pageNumber }));
  }, [
    createdProduct,
    dispatch,
    props.history,
    successCreate,
    successDelete,
    pageNumber,
  ]);

  const createHandler = () => {
    dispatch(createProduct());
  };

  const deleteHandler = (product) => {
    if (window.confirm("Are you sure to delete?")) {
      dispatch(deleteProduct(product._id));
    }
  };

  return (
    <div>
      <NavBar />
      <div className="container ">
        <div className="row content create mt-5">
          <h3 className="mb-3">Create Product</h3>
          <div className=" d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-warning"
              onClick={createHandler}
            >
              Create Product
            </button>
          </div>
        </div>
        {loadingDelete && <LoadingBox></LoadingBox>}
        {errorDelete && <MessageBox variant="danger">{errorDelete}</MessageBox>}
        {loadingCreate && <LoadingBox></LoadingBox>}
        {errorCreate && <MessageBox variant="danger">{errorCreate}</MessageBox>}
        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <div className="table-responsive productlist mb-5  mt-5  ">
            <table className="table table-striped table-hover text-center">
              <thead>
                <tr className="">
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Price</th>
                  <th scope="col">Cat.</th>
                  <th scope="col">Brand</th>
                  <th scope="col">Actions</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {products.products.map((p) => (
                  <tr className="" key={p._id}>
                    <th scope="row">{p._id.slice(p._id.length - 6)}</th>
                    <td>{p.name}</td>
                    <td>{p.price}</td>
                    <td>{p.category}</td>
                    <td>{p.brand}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-secondary  btn-sm "
                        onClick={() =>
                          props.history.push(`/products/${p._id}/edit`)
                        }
                      >
                        Edit
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm "
                        onClick={() => deleteHandler(p)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="row d-flex">
              <ul className="pagination mx-auto justify-content-center ">
                {[...Array(pages).keys()].map((x) => (
                  <li className="page-item px-2 fst-italic" key={x + 1}>
                    <Link
                      className={
                        x + 1 === page
                          ? "active text-decoration-none fw-bold"
                          : "text-decoration-none"
                      }
                      to={`/productlist/pageNumber/${x + 1}`}
                    >
                      {x + 1}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default ProductListPage;

// function ProductsPage(props) {
//   const [modalVisit, setModalVisible] = useState(false);
//   const [id, setId] = useState("");
//   const [name, setName] = useState("");
//   const [price, setPrice] = useState("");
//   const [category, setCategory] = useState("");
//   const [image, setImage] = useState("");
//   const [brand, setBrand] = useState("");
//   const [countInStock, setCountInStock] = useState("");
//   const [description, setDescription] = useState("");

//   const productList = useSelector((state) => state.productList);
//   const { loading, products, error } = productList;

//   const productSave = useSelector((state) => state.productSave);
//   const {
//     loading: loadingSave,
//     success: successSave,
//     error: errorSave,
//   } = productSave;

//   const productDelete = useSelector((state) => state.productDelete);
//   const {
//     loading: loadingDelete,
//     success: successDelete,
//     error: errorDeletee,
//   } = productDelete;

//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (successSave) {
//       setModalVisible(false);
//     }
//     dispatch(listProducts());

//     return () => {
//       //
//     };
//   }, [successSave, successDelete]);

//   const openModal = (product) => {
//     setModalVisible(true);
//     setId(product._id);
//     setName(product.name);
//     setPrice(product.price);
//     setDescription(product.description);
//     setImage(product.image);
//     setBrand(product.brand);
//     setCategory(product.category);
//     setCountInStock(product.countInStock);
//   };

//   const submitHandler = (e) => {
//     //will not refresh page while users submit forms
//     e.preventDefault();
//     dispatch(
//       saveProduct({
//         _id: id,
//         name,
//         price,
//         image,
//         brand,
//         category,
//         countInStock,
//         description,
//       })
//     );
//   };

//   const deleteHandler = (product) => {
//     dispatch(deleteProduct(product._id));
//   };

//   return (
//     <div>
//       <NavBar />
//       <div className="container ">
//         <div className="row content">
//           <div className="row justify-content-between content_header mt-4">
//             <div className="col-4">
//               <p>Products</p>
//             </div>
//             <div className="col-3  create_btn  ">
//               <button
//                 onClick={() => openModal({})}
//                 type="button"
//                 className="btn btn-warning "
//               >
//                 Create
//               </button>
//             </div>
//           </div>
//           {modalVisit && (
//             <div className="row ">
//               <form
//                 className="signin mt-5 mb-5 col col-lg-8 "
//                 onSubmit={submitHandler}
//               >
//                 <div className="mb-4">
//                   <h3 className="">Create Product</h3>
//                 </div>
//                 {loadingSave && <div>Loading...</div>}
//                 {errorSave && <div>{errorSave}</div>}

//                 <div className="row g-3">
//                   <div className="col mb-3">
//                     <label htmlFor="name" className="form-label">
//                       Name
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control "
//                       id="name"
//                       value={name}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                   </div>
//                   <div className="col mb-4">
//                     <label htmlFor="price" className="form-label">
//                       Price
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="price"
//                       value={price}
//                       onChange={(e) => setPrice(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <div className="row g-3">
//                   <div className="col mb-4">
//                     <label htmlFor="image" className="form-label">
//                       Image
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="image"
//                       value={image}
//                       onChange={(e) => setImage(e.target.value)}
//                     />
//                   </div>
//                   <div className="col mb-4">
//                     <label htmlFor="brand" className="form-label">
//                       Brand
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="brand"
//                       value={brand}
//                       onChange={(e) => setBrand(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <div className="row g-3">
//                   <div className="col mb-4">
//                     <label htmlFor="countInStock" className="form-label">
//                       CountInStock
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="countInStock"
//                       value={countInStock}
//                       onChange={(e) => setCountInStock(e.target.value)}
//                     />
//                   </div>
//                   <div className="col mb-4">
//                     <label htmlFor="category" className="form-label">
//                       Category
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="category"
//                       value={category}
//                       onChange={(e) => setCategory(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <div className="mb-4">
//                   <label htmlFor="description" className="form-label">
//                     Description
//                   </label>
//                   <textarea
//                     className="form-control"
//                     id="description"
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                   />
//                 </div>

//                 <div className="row g-3">
//                   <div className="col mb-4 ">
//                     <button type="submit" className="btn btn-warning ">
//                       {id ? "Update" : "Create"}
//                     </button>
//                   </div>
//                   <div className="col mb-4 ">
//                     <button
//                       type=""
//                       onClick={() => setModalVisible(false)}
//                       className="btn btn-secondary "
//                     >
//                       Back
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           )}

//           <div className="table-responsive productlist mb-5  mt-5  ">
//             <table className="table table-striped table-hover text-center">
//               <thead>
//                 <tr className="">
//                   <th scope="col">ID</th>
//                   <th scope="col">Name</th>
//                   <th scope="col">Price</th>
//                   <th scope="col">Cat.</th>
//                   <th scope="col">Brand</th>
//                   <th scope="col">Edit</th>
//                   <th scope="col">Delete</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {products.map((p) => (
//                   <tr className="" key={p._id}>
//                     <th scope="row">{p._id.slice(p._id.length - 6)}</th>
//                     <td>{p.name}</td>
//                     <td>{p.price}</td>
//                     <td>{p.category}</td>
//                     <td>{p.brand}</td>
//                     <td>
//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary  btn-sm "
//                         onClick={() => openModal(p)}
//                       >
//                         Edit
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary btn-sm "
//                         onClick={() => deleteHandler(p)}
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// }

// export default ProductsPage;
